import React from "react";
import { Navigate } from "react-router-dom";

// Plans are unlocked per region from the Journey page.
const Subscription: React.FC = () => <Navigate to="/journey" replace />;

export default Subscription;
